export default __webpack_public_path__ + "static/media/ic-back-white.d81cfdd3.svg";